import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  isEndReachedBySearchInput,
  isLoadingBySearchInput,
  recentSearches,
  searchInput,
  searchResultsBySearchInput,
} from '/redux/selector/search.selector';
import {withHOC} from '/util/hoc.util';

import {SearchResults} from './SearchResults';

export const SearchResultsConnected = withHOC(
  connect(
    createStructuredSelector({
      searchResults: searchResultsBySearchInput,
      recentSearches,
      isLoading: isLoadingBySearchInput,
      isEndReached: isEndReachedBySearchInput,
      searchInput,
    }),
  ),
)(SearchResults);
